<template>
  <div id="operatehuhui">
    <!-- <span v-loading.fullscreen.lock="fullscreenLoading"></span> -->
    <CommonLoading ref="commonLoader"></CommonLoading>
    <div class="trader-body">
      <!--<div class="gppzys">
        <span>配资优势</span>
        <img src="../assets/img/cpic.png">
      </div>-->
      <!--<ul class="gppzys-nr">
        <li>
          <img src="../assets/img/pzfqcg.png">
          <div class="gppzys-r">
            <p>配资发起成功</p>
            <p>5分钟内下户(开盘前下户)</p>
          </div>
          <div class="clear"></div>
        </li>
        <li>
          <img src="../assets/img/cpyltq.png">
          <div class="gppzys-r">
            <p>配资盈利提取</p>
            <p>5分钟到会员账户</p>
          </div>
          <div class="clear"></div>
        </li>
        <li>
          <img src="../assets/img/txmdz.png">
          <div class="gppzys-r">
            <p>提现秒到账</p>
            <p>5分钟内到达银行卡</p>
          </div>
          <div class="clear"></div>
        </li>
        <li style="margin-right:0">
          <img src="../assets/img/mccp.png">
          <div class="gppzys-r">
            <p>100%满仓配资</p>
            <p>单支股票无仓位限制</p>
          </div>
          <div class="clear"></div>
        </li>
        <div class="clear"></div>
      </ul>
      <div class="gppzys">
        <span>股票配资流程</span>
        <img src="../assets/img/cpic.png">
      </div>-->
     <!-- <div class="gppzlc">
        <img src="../assets/img/peiziimg2.jpg">
      </div>-->
      <div class="trader-at">
        <el-card class="box-card" shadow="never">
          <el-row>
            <el-col :span="20">
              <el-form ref="form" label-width="150px" label-position="right">
                <el-form-item>
                  <span slot="label" class="assist_title">保证金:</span>
                  <el-input
                    v-model.number="principal"
                    placeholder="请输入金额（100-300万，一百整数倍）"
                    type="number"
                    @keyup.native="principalChange"
                    style="width: 100%"
                  >
                  <template slot="prefix">
    <span style="color: black; font-size: 16px; line-height: 50px;margin-left:10px">¥</span>
  </template>
                </el-input>
                  <!-- <p class="infoColor">{{ info.explain }}</p> -->
                </el-form-item>
                <el-form-item v-if="principal>0">
                  <span slot="label" class="assist_title">配资资金:</span>
                  <div class="multiple_box" v-for="(item,index) in multiple" :key="index">
                    <div class="multiple"     :class="{capital_ul2_active: cut == index}"  @click="setCut(index,item)">
                      <a href="javascript:void(0);">
                        <p class="multiple_detail">
                          {{item[0]}}倍
                        </p>
                        <p class="multiple_money">{{parseFloat(item[3]).toFixed(2)}}元</p>
                      </a>
                    </div>
                  </div>
                  <!--<el-row :gutter="10">
                    <el-col
                      :span="4"
                      v-for="(item,index) in multiple"
                      :key="index">
                      <div class="multiple"     :class="{capital_ul2_active: cut == index}"  @click="setCut(index,item)">
                        <a href="javascript:void(0);">
                          <p class="multiple_detail">
                            {{item[0]}}倍
                          </p>
                          <p class="multiple_money">{{item[3]}}元</p>
                        </a>
                      </div>
                    </el-col>
                  </el-row>-->
                </el-form-item>
                <el-form-item >
                  <span slot="label" class="assist_title">免息说明:</span>
                  <div style="border:1px solid #f1f1f1;padding:20px;line-height:25px">
                    <span class="black" style="font-size: 13px;" v-for="(item,index) in explain" :key="index">({{index+1}}){{item}}<br></span>
                </div>
                </el-form-item>
                <el-form-item>
                  <span slot="label" class="assist_title">配资信息:</span>
                  <div class="money_info">

                    <el-row  style="border:1px solid #f1f1f1;">
                <el-col :span="5" style="text-align: center;line-height: 30px;background-color: #f2f2f2;" >
                  <h4>总配资金额</h4>
                  <h4 style="margin-left:22px;">亏损预警线 <el-tooltip
                              class="item"
                              effect="dark"
                              content="当总配资资金低于预警线以下时，只能平仓不能建仓"
                              placement="top-start"
                              ><i class="el-icon-question" style="color:#0D268D;font-size: 20px;"></i></el-tooltip
                          ></h4>
                  <h4 style="margin-left:22px;">亏损平仓线 <el-tooltip
                              class="item"
                              effect="dark"
                              content="当总配资资金低于平仓线以下时，我们将有权把您的股票进行平仓，为避免平仓发生，请时刻关注本金是否充足"
                              placement="top-start"
                              ><i class="el-icon-question" style="color:#0D268D; font-size:20px;"></i></el-tooltip
                          ></h4>
                </el-col>
                
                <el-col :span="18" style="text-align: left;line-height: 30px;margin-left:20px;" >
                 <span> 
                  {{parseFloat(allMoney).toFixed(2)}}元={{ principal }}(保证金)+ {{parseFloat(money).toFixed(2)}}元(配资资金)

                 </span>
                 <br>
                 <span> 
                  {{parseFloat(warning).toFixed(2)}}元（预警线 = 配资资金 + 保证金 X {{info.warning}}）

                 </span>
                 <br>
                 <span> 
                  {{parseFloat(close).toFixed(2)}}元（平仓线 = 配资资金 + 保证金 X {{info.close}}）

                 </span>
                </el-col>
</el-row>
                    <!-- <table>
                      <tr>
                        <td>
                          <span class="info_title">总配资金额</span>
                        </td>
                        <td>
                          <span>
                                 {{parseFloat(allMoney).toFixed(2)}}元={{ principal }}(保证金)+ {{parseFloat(money).toFixed(2)}}元(配资资金)
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span class="info_title">亏损预警线<el-tooltip class="item" effect="dark" content="当总配资资金低于预警线以下时，只能平仓不能建仓" placement="top-start"><i class="el-icon-question red"></i></el-tooltip></span>
                        </td>
                        <td>
                          <span>
                            {{parseFloat(warning).toFixed(2)}}元（预警线 = 配资资金 + 保证金 X {{info.warning}}）
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span class="info_title">亏损平仓线<el-tooltip class="item" effect="dark" content="当总配资资金低于平仓线以下时，我们将有权把您的股票进行平仓，为避免平仓发生，请时刻关注本金是否充足" placement="top-start"><i class="el-icon-question red"></i></el-tooltip></span>
                        </td>
                        <td>
                          <span>
                            {{parseFloat(close).toFixed(2)}}元（平仓线 = 配资资金 + 保证金 X {{info.close}}）
                          </span>
                        </td>
                      </tr>
                    </table> -->
                  </div>
                </el-form-item>


                <el-form-item>
                  <span slot="label" class="assist_title">结算信息:</span>
                  <div class="money_info">
                    <el-row  style="border:1px solid #f1f1f1;font-weight: bold;">
                <el-col :span="5" style="text-align: center;line-height: 30px;background-color: #f2f2f2;" >
                  <h4>保证金</h4>
                  <h4>管理费 </h4>
                  <h4>代金券</h4>
                  <h4>合计</h4>
                </el-col>
                
                <el-col :span="18" style="text-align: left;line-height: 30px;margin-left:20px;" >
                  <span v-if="principal>0"> 
                  {{ principal }}元
                 </span>
                 <span v-else> 
                   0.00元
                 </span>
                 <br>
                 <span> 
                  0.00元 <span style="color:#0D268D">（第30天14：30后平台择机平仓）</span>
                </span>
                 <br>
                 <span> 
                  -0.00元
                 </span>
                 <br>
                 <span style="color:#0D268D"> 
                  {{ ((parseFloat(principal) || 0))}}元
                 </span>
                </el-col>
</el-row>

                  </div>
                </el-form-item>
                <el-form-item>
                    <input type="checkbox" class="check" v-model="agree">
                    <span style="font-weight: bold;font-size:12px;">我已阅读并同意</span>
                    <router-link to="/operate/protocol"><span style="color:#0D268D;font-weight: bold;font-size:12px;">《配资合作协议》</span></router-link>
                  <!-- <p><span class="red info_title">实付款:{{ payMoney }} </span>保证金{{ principal }}元</p> -->
                </el-form-item>
                <el-form-item>
                  <el-row  style="margin-top:5px;">
                    <el-col :span="8" ><span class="text_red_color">¥{{ ((parseFloat(principal) || 0) + (parseFloat(fee)) - (Number(voucher_management))).toFixed(2) }}</span>
                    </el-col>
                    <el-col :span="8">&nbsp;</el-col>

                    <el-col :span="8"> 
                      <p class="center">可用余额:{{ user.cash }}元 代金券:{{ user.voucher_management }}</p>
                    </el-col>
                  </el-row>
                </el-form-item>
                <el-form-item>
                  <el-row style="margin-top:-6px">
                    <el-col :span="8" >
                      <p style="font-size: 12px;">共减¥{{(Number(voucher_management))}}</p>
                    </el-col>
                    <el-col :span="8">&nbsp;</el-col>

                    <el-col :span="8"> 
                      <el-button type="primary" style="width: 100%;background: #0D268D; border: #0D268D;color: #ffffff" @click="operateBtn" >申请配资</el-button>
                    </el-col>
                  </el-row>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
        </el-card>
      </div>
      <!--<div class="gppzys">
        <span>选择配资方案</span>
        <img src="../assets/img/cpic.png">
      </div>
      <div class="trader-at">
        <div class="trader-at-l">
          <p class="trader-at-tit">
            <span class="height33">配资类型</span>
            <el-button
              v-for="(item,index) in allData"
              :key="index"
              :class="$store.state.type == index ? 't-btn-act' : '' "
              @click.native="setType(index,item)"
              class="t_btn"
              type="danger"
              plain
            >{{item.data.short}}</el-button>
          </p>
          <p class="trader-at-tit">第一步：输入投资本金({{info.min_num}}-{{info.max_num}})</p>
          <el-input
            class="operate-input"
            v-model.number="principal"
            :placeholder="info.explain"
            id="input1"
            type="number"
            @keyup.native="principalChange"
          ></el-input>
          <p class="note">备注：{{info.explain}}</p>
          <p class="trader-at-tit">第二步：选择获得资金(选择杠杆，资金放大10倍)</p>
          <ul class="ksxz">
            <li
              v-for="(item,index) in multiple"
              :key="index"
              :class="{capital_ul2_active: cut == index}"
              @click="setCut(index,item)"
            >
              <p>
                <span class="b30">{{item[0]}}</span>倍
              </p>
              <p>{{item[3]}}元</p>
            </li>
          </ul>
        </div>
        <div class="trader-at-r">
          <p class="trader-at-tit">第三步：选择你的配资周期</p>
          <p class="mar-l-6">期限：固定15个交易日</p>
          <p class="note">备注：第15个交易日14:30终止配资并结算</p>
          <p class="trader-at-tit">第三步：选择开始交易时间</p>
          <p class="mar-l-6" id="p1">
            <span class="ljsx capital_ul2_active">立即生效</span>
          </p>
          <p class="trader-at-tit">第五步：确认配资信息</p>
          <table border="1" class="tab">
            <tr>
              <th>配资须知</th>
              <th>{{scale}}</th>
            </tr>
            <tr>
              <td>总配资资金</td>
              <td>
                <span class="cor-y allMoney">{{allMoney}}元</span>&nbsp;
                <span class="span1">{{principal}}(本金)+{{money}}(配资资金)</span>
              </td>
            </tr>
            <tr>
              <td>亏损警戒线</td>
              <td>
                <span class="cor-y span2">{{warning}}元</span>
                &nbsp;(预警线=配资资金*{{info.warning}})
              </td>
            </tr>
            <tr>
              <td>亏损平仓线</td>
              <td>
                <span class="cor-y span3">{{close}}元</span>
                &nbsp;(平仓线=配资资金*{{info.close}})
              </td>
            </tr>
          </table>
        </div>
        <div class="clear"></div>
      </div>
      <p class="tet-cen cor-y">
        备注：您需要支付的金额为：保证金
        <span class="span4">{{principal}}</span>元
        <span class="m_span2">(准备资金 = 投资本金)</span>
      </p>
      <p class="tet-cen">如果您不清楚规则，或有其他疑问，请联系客服</p>
      <p class="tet-cen p2">
        <input type="checkbox" class="check" v-model="agree">
        <span>我已阅读并同意</span>
        <router-link to="/operate/protocol">《配资合作协议》</router-link>
      </p>
      <el-button class="cp-btn" type="danger" @click="operateBtn" :disabled="disabled">我要配资</el-button>
      <div class="border"></div>
      <div class="cpxz">
        <div class="cpxz-tit">配资须知</div>
        <div v-html="tips"></div>
      </div>-->
    </div>
    <!-- 购买成功弹窗-->
    <span class="instead"></span>
    <Operatesuccess
      class="operate-success"
      :paymoney="payMoney"
      :close="close"
      :fee="dayFee"
      :allmoney="allMoney"
      :principal="principal"
      :warning="warning"
      :voucher_management="voucher_management"
      dateText="30天"
    ></Operatesuccess>
    <!--余额不足-->
    <Operatefail
      :principal="principal"
      :allmoney="allMoney"
      :fee="dayFee"
      :close="close"
      :warning="warning"
      :paymoney="payMoney"
      :balance="balance"
      :lack="lack"
      class="operate-fail"
    ></Operatefail>
    <!-- ============================== Start change channel popup ========================== -->
    <el-dialog
      :visible.sync="showTradeChannelPopup"
      width="40%"
      center
      custom-class="tradingChannelPop"
    >
      <div v-html="trade_rules_content_top"></div>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="agreeTradeRules()"
          style="background: #ff0000; border-color: #ff0000; width: 200px"
          >我已经明白
        </el-button>
        <div
          v-html="trade_rules_content_bottom"
          style="padding-top: 10px"
        ></div>
      </span>
    </el-dialog>
    <!-- ============================== end change channel popup ========================== -->
  </div>
</template>
<script>
import $ from "jquery";
import Operatesuccess from "./module/operatesuccess";
import Operatefail from "./module/operatefail";
import CommonLoading from "./common/commonLoading";
export default {
  components: {
    Operatesuccess,
    Operatefail,
    CommonLoading
  },
  data() {
    return {
      info: {
        close: 0.3,
        delay: 20,
        explain: "最少2千,最多200万,1百整倍数",
        max_num: 2000000,
        min_num: 2000,
        min_time: 2,
        name: "按天配资",
        times: 100,
        warning: 0.5,
      },
      explain:[],
      multiple: [],
      cut: 0, //控制杠杆样式
      principal: "", //本金
      money: 0.0, //借款金额
      allMoney: 0.0, //总配资资金
      fee: 0.0, //账户管理费
      dayFee: 0.0, //按天的管理费
      warning: 0.0, //预警线
      close: 0.0, //平仓线
      payMoney: 0.0, //付款金额
      agree: true, //同意协议
      balance: 0.0, //余额
      lack: 0.0, //余额不足的差价
      disabled: false, //我要配资按钮的 防止连点
      type: 0, //选择互惠配资的方式 例如T-7
      allData: [], //返回的所有信息 目的：循环互惠配资的方式
      selectShort: "", //选择的 挥挥配资方式的 短语short
      tips: "", //配资须知
      scale: "", //分红比例
      voucher_management:0.00,
      user:{
        loginType:false,
        //代金券
        voucher_management:0.00,
        //可用余额
        cash:0.00
      },
      trade_channel_status: "",
      showTradeChannelPopup: false,
      trade_rules_content_top: "",
      trade_rules_content_bottom: "",
      fullscreenLoading: false
    };
  },
  mounted() {
    this.getHuiInfo();
    // this.getTips();
    if (this.$store.state.loginType){
      this.getUserinfo();
    }
  },
  methods: {
    getUserinfo() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "user",
            token: sessionStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code == 1) {
            that.user.loginType = true;
            that.user.cash = res.data.data.cash;
            that.user.voucher_management = res.data.data.voucher_management;
            that.trade_channel_status = res.data.data.trade_channel_status;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.user.loginType = false;
            that.$message.error(res.data.msg);
          }
        });
    },
    //获取互惠信息
    getHuiInfo() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "mutual_info"
          }
        })
        .then(function(res) {
          if (res.data.code == 1) {
            var index = that.$store.state.type;
            that.allData = res.data.data;
            var data = res.data.data[index];
            var short = data.data.short;
            if (short == "T+30") {
              that.scale = "盈利5成全归您";
            } else if (short == "T+7") {
              that.scale = "盈利7成全归您";
            }
            that.explain = data.explain;
            that.selectShort = data.data.short;
            that.info = data.data;
            that.multiple = data.multiple;
            that.multiple.sort(function (a,b) {
              return b[0] - a[0];
            });
            // that.principal = ''; //本金
            // $.each(that.multiple, function(index, item) {
            //   item.push((item[1] * 100).toFixed(2)); //百分比
            //   item.push(that.info.min_num * item[0]); //借款金额
            // });
            // that.money = that.multiple[that.cut][3]; //借款金额
            // that.allMoney = that.money + that.principal; //总配资资金
            // that.warning = that.principal * that.info.warning + that.money; //警戒线
            // that.close = that.principal * that.info.close + that.money; //平仓线
            // that.payMoney = that.principal.toFixed(2); //付款金额
          } else if (res.data.code == 0) {
            that.$message.error(res.data.msg);
          }
        });
    },
    //切换互惠配资方式
    setType(index, item) {
      let that = this;
      var short = item.data.short;
      if (short == "T+30") {
        that.scale = "盈利5成全归您";
      } else if (short == "T+7") {
        that.scale = "盈利7成全归您";
      }
      that.$store.state.type = index;
      window.sessionStorage.setItem("type", index);
      var data = that.allData[index];
      that.selectShort = data.data.short;
      that.info = data.data;
      that.principal = that.info.min_num; //本金
      $.each(that.multiple, function(index, item) {
        item[3] = that.info.min_num * item[0];
      });
      that.money = that.multiple[that.cut][3]; //借款金额
      that.allMoney = that.principal + that.money; //总资金
      that.warning = that.allMoney * that.info.warning; //警戒线
      that.close = that.allMoney * that.info.close; //平仓线
      that.payMoney = that.principal.toFixed(2); //付款金额
    },
    //选择杠杆
    setCut(index, item) {
      let that = this;
      that.cut = index;
      that.money = item[3]; //借款金额
      that.fee = (item[3] * item[1]).toFixed(2); //管理费
      that.dayFee = parseFloat(that.fee).toFixed(2); //按天配资的管理费
      that.allMoney = that.money + that.principal; //总配资资金
      that.warning = that.principal * that.info.warning + that.money; //警戒线
      that.close = that.principal * that.info.close + that.money; //平仓线
      that.payMoney = that.principal.toFixed(2); //付款金额
    },
    //本金变动计算
    principalChange() {
      let that = this;
      if (that.principal == "") {
        that.zero();
      } else {
        if (that.principal >= that.info.max_num) {
          that.principal = that.info.max_num;
        } else {
          that.principal = that.principal;
        }
        $.each(that.multiple, function(index, item) {
          item[3] = parseFloat(that.principal) * item[0];
        });
        that.money = that.multiple[that.cut][3]; //借款金额
        that.allMoney = that.money + that.principal; //总操盘资金
        that.warning = that.principal * that.info.warning + that.money; //警戒线
        that.close = that.principal * that.info.close + that.money; //平仓线
        that.payMoney = that.principal.toFixed(2); //付款金额
      }
    },
    zero() {
      let that = this;
      $.each(that.multiple, function(index, item) {
        item[3] = "0.00";
      });
      that.money = "0.00"; //借款金额
      that.fee = "0.00"; //管理费
      that.dayFee = "0.00"; //按天配资的管理费
      that.allMoney = "0.00"; //总操盘资金
      that.warning = "0.00"; //警戒线
      that.close = "0.00"; //平仓线
      that.payMoney = "0.00"; //付款金额
    },
    //我要配资操作
    operateBtn() {
      let that = this;
      if (sessionStorage.getItem("token") == null) {
        that.$message.error("请先登录");
      } else if (that.agree == false) {
        that.$message.error("请先阅读协议书");
      } else {
        //1、T+30 。2、 T+7
        var huiType = that.$store.state.type + 1;
        that.disabled = true;
        setTimeout(function() {
          that.disabled = false;
        }, 3000);
        //流程：请求余额  显示 余额不足弹窗 或者 确认购买弹窗
        if (that.trade_channel_status == 1) {
          that.getTradeChannel();
        } else {
        // that.fullscreenLoading = true;
        that.$refs.commonLoader.showCommonLoadigIcon();
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "user",
              token: sessionStorage.getItem("token")
            }
          })
          .then(function(res) {
            if (res.data.code == 1) {
              // that.fullscreenLoading = false;
              that.$refs.commonLoader.hideCommonLoadigIcon();
              that.balance = parseFloat(res.data.data.cash);
              if (that.balance >= that.payMoney) {
                //余额充足
                // that.fullscreenLoading = true;
                that.$refs.commonLoader.showCommonLoadigIcon();
                that
                  .$http({
                    url: "/",
                    method: "post",
                    data: {
                      nozzle: "apply_mutual",
                      token: sessionStorage.getItem("token"),
                      bond: that.principal,
                      multiple: that.multiple[that.cut][0],
                      type: huiType //互惠配资的方式
                    }
                  })
                  .then(function(res) {
                    if (res.data.code == 1) {
                      $(".operate-success").fadeIn(100);
                    } else if(res.data.code == 2){
                      that.getTradeChannel();
                    } else if (res.data.code == 0 || res.data.code == -1) {
                      that.$message.error(res.data.msg);
                    }
                  }).finally(() => {
                      // that.fullscreenLoading = false;
                      that.$refs.commonLoader.hideCommonLoadigIcon();
                  });
              } else {
                //余额不足
                that.lack = that.payMoney - that.balance;
                $(".operate-fail").fadeIn(100);
              }
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$message.error(res.data.msg);
            }
          }).finally(() => {
              // that.fullscreenLoading = false;
              that.$refs.commonLoader.hideCommonLoadigIcon();
          });
        }
      }
    },
    // ============= get the content of trade channel popup agreement ===========
    getTradeChannel() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "trade_popup",
            token: sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.trade_rules_content_top = res.data.data.content_top;
            that.trade_rules_content_bottom = res.data.data.content_bottom;
            that.showTradeChannelPopup = true;
          } else {
          }
        });
    },

    // ============================== Click agree the trade rules ========================
    agreeTradeRules() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "modify_trade_status",
            token: sessionStorage.getItem("token"),
            trade_channel_status: 1,
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.$message({
              message: res.data.msg,
              type: "success",
              duration: 1000,
            });
            that.showTradeChannelPopup = false;
            that.trade_channel_status = 0;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        });
    },

    isMultiple(){
      let that = this;
      let principal = parseInt(that.principal);
      if (isNaN(principal) || principal === '' || principal < Number(that.info.min_num) || principal > Number(that.info.max_num)){
        that.principal = 0;
        that.zero();
      }else{
        principal = parseInt(principal/100)*100;
        that.principal = principal;
      }
      that.principalChange();
    },
    //配资须知
    getTips() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "operate_notice"
          }
        })
        .then(function(res) {
          if (res.data.code == 1) {
            that.tips = res.data.data;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        });
    }
  }
};
</script>
<style scoped>
@import url("./../assets/css/operate.css");
.ksxz > li > p:first-child {
  font-size: 30px;
  height: 35px;
}
.ksxz > li > p > span {
  font-size: 40px;
}
.ksxz > li > p:nth-child(2) {
  margin-top: 20px;
}
.operate-input {
  margin-left: 6%;
  width: 70%;
  height: 40px;
}
.operate-success,
.operate-fail {
  display: none;
}
.t_btn {
  height: 33px;
  line-height: 0px;
  margin-left: 10px;
  padding: 0 10px;
}
.t-btn-act {
  background: #f56c6c !important;
  color: #fff !important;
}
.height33 {
  display: inline-block;
  line-height: 33px;
}
.assist_title{
  font-weight: bold;
  font-size: 20px;
}
.multiple{
  border-radius: 4px;
  padding: 15px 0;
  border: 1px solid #9a9a9a;
}
.multiple p{
  text-align: center;
  line-height: 1.6;
  font-size: 18px;
  font-weight: bold;
  color: #98989a;
}
.multiple_detail{
  /*padding-top: 10px;*/
}
.capital_ul2_active p{
  color: #FFFFFF !important;
}
.money_info{
  border-radius: 4px;
}
.money_info p{
  font-size: 16px;
}
.info_title{
  font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
  font-weight: bold;
  font-size: 16px;
}
.multiple_box{
  width: 19%;
  float: left;
  margin-right: 1.25%;
}
.multiple_box:last-child{
  margin-right: 0;
}
.infoColor{
  color: #909399;
}
.capital_ul2_active{
  background: #0D268D;
  color: #fff !important;
  border: 1px solid #0D268D !important;
}
/deep/ .el-input__inner{
  background-color:#f2f2f2 !important;
  border:20px;
  height:50px;
}
.check {
    width: 20px;
    height: 20px;
    appearance: none; 
    border: 2px solid #0D268D;
    background-color: white; 
    border-radius: 4px;
    cursor: pointer;
    position: relative;
  }

  .check:checked {
    background-color: #0D268D; 
  }

  .check:checked::after {
    content: '✔'; 
    position: absolute;
    color: white;
    font-size: 16px;
    font-weight: bold;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  .text_red_color{
    font-size: 22px !important;
    color:#0D268D !important;
  }
  /deep/ .el-form-item__content {
    line-height: 1px;
}
</style>
<style>
.tradingChannelPop .el-dialog__body {
  padding: 0px 20px;
}

/* .tradingChannelPop .el-dialog__header {
  display: none;
} */
</style>




// WEBPACK FOOTER //
// src/components/operatehuhui.vue